export const prepareStarsForView = (stars = 0) => stars / 100;
